module.exports = "<svg id=\"ca5e6ceb-8e01-4bc7-90cb-5f4d25908b9d\" data-name=\"517da36d-cbd6-4556-bfad-127be1e250b4\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 45.56 48.64\"><title>Avatar</title><circle cx=\"22.78\" cy=\"12.81\" r=\"12.81\"></circle><path d=\"M45.56,48.64v-4.5A14.28,14.28,0,0,0,31.32,29.9H14.24A14.28,14.28,0,0,0,0,44.14v4.51Z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/Avatar.svg
// module id = 509
// module chunks = 1